import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observer, Subscription, switchMap, tap } from 'rxjs';
import { PraticaStats } from '../../pratica/models/pratica-stats';
import { KpiInfo } from '../../requests/models/kpi-model';
import { ProductService } from '../../_core/services/product.service';
import { LabelPipeModule } from '../../_shared/label-pipe/label-pipe.module';
import { SharedModule } from '../../_shared/shared.module';
import { AuthService } from '../../_core/services/auth.service';
import { DialogService } from '../../_core/services/dialog.service';
import { OutsystemService } from '../../_core/services/outsystem.service';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { KpiFactory } from '../../requests/models/kpi-factory';
import { SfUtils, SmartFormComponent } from 'ngx-smart-form';

@Component({
  selector: 'app-kpi-table',
  templateUrl: './kpi-table.component.html',
  styleUrls: ['./kpi-table.component.scss'],
  standalone: true,
  imports: [SharedModule, LabelPipeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiTableComponent implements OnInit, OnDestroy {
  @ViewChildren(SmartFormComponent)
  smartFormComponentList?: QueryList<SmartFormComponent>;

  data: KpiInfo[] = [];
  displayedColumns: (keyof KpiInfo)[] = ['Nome', 'Valore', 'Valutazione'];

  section: PraticaStats | '' = '';

  productSubscription?: Subscription;

  constructor(
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private outsystemService: OutsystemService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.section = this.activatedRoute.snapshot.url[0]?.path as PraticaStats;
    this.productSubscription =
      this.productService.analisiCreditoProduct$.subscribe((prod) => {
        if (this.section) {
          this.data = KpiFactory.getModuloInfo(prod?.kpi, this.section, 1);
          this.cdr.detectChanges();
        }
      });
  }

  ngOnDestroy(): void {
    this.productSubscription?.unsubscribe();
  }

  updateValutazione() {
    if (!this.productService.analisiCreditoProduct?.kpi || !this.section)
      return;
    let observer: Observer<any> = {
      next: (res) => this.dialogService.onSuccess(),
      error: (err) => this.dialogService.manageError(err),
      complete: () => {
        this.cdr.detectChanges();
      },
    };
    let data = KpiFactory.updateKpiModule(
      this.productService.analisiCreditoProduct?.kpi,
      SfUtils.aggregateFormsValues(this.smartFormComponentList?.toArray()),
      this.section
    );
    this.outsystemService
      .updateKpi(data)
      .pipe(
        switchMap((res) => {
          return this.productService
            .edit({ kpi: res }, this.productService.analisiCreditoProduct!.id)
            .pipe(
              tap(
                (_) =>
                  (this.productService.analisiCreditoProduct = {
                    ...this.productService.analisiCreditoProduct!,
                    kpi: res,
                  })
              )
            );
        })
      )

      .subscribe(observer);
  }

  get inputFieldsAreValid() {
    return SfUtils.isValid(this.smartFormComponentList?.toArray());
  }
}
